import { ACTIONS_USER } from '../_constants/user.constants';

const initialState = {
  byId: {},
};

export function userReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_USER.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_USER.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_USER.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default userReducer;
